import { render } from "./InvalidPotentialPopup.vue?vue&type=template&id=3a802bc2&lang=pug"
import script from "./InvalidPotentialPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./InvalidPotentialPopup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__